export const trackingPendoId = '78b2e650-a741-4271-a44f-1d1664a0744a'